(function () {
  var ERROR_TEXT = 'Variant can only be purchased with a selling plan.';
  var STARTER_HANDLE = 'haro-clear-starter-kit';
  var STARTER_VARIANT_ID = '52538893238588';
  var STARTER_SELLING_PLAN_ID = '694030500156';

  function getSelectedVariantData(productInfo) {
    if (!productInfo) return null;
    var script = productInfo.querySelector('script[data-selected-variant]');
    if (!script) return null;
    try {
      return JSON.parse(script.textContent || '{}');
    } catch (e) {
      return null;
    }
  }

  function getDefaultSellingPlanIdFromVariant(variant, productHandle) {
    if (!variant || !variant.selling_plan_allocations || !variant.selling_plan_allocations.length) return '';
    if ((productHandle === STARTER_HANDLE || String(variant.id) === STARTER_VARIANT_ID) && String(variant.id) === STARTER_VARIANT_ID) {
      return STARTER_SELLING_PLAN_ID;
    }
    var allocation = variant.selling_plan_allocations[0];
    if (!allocation || !allocation.selling_plan_id) return '';
    return String(allocation.selling_plan_id);
  }

  function getSellingPlanFieldValue(form) {
    if (!form) return '';

    var checked = form.querySelector('input[name="selling_plan"]:checked');
    if (checked) return checked.value || '';

    var input = form.querySelector('input[name="selling_plan"]');
    if (input) return input.value || '';

    var select = form.querySelector('select[name="selling_plan"]');
    if (select) return select.value || '';

    if (form.id) {
      var externalChecked = document.querySelector('input[name="selling_plan"][form="' + form.id + '"]:checked');
      if (externalChecked) return externalChecked.value || '';

      var externalInput = document.querySelector('input[name="selling_plan"][form="' + form.id + '"]');
      if (externalInput) return externalInput.value || '';

      var externalSelect = document.querySelector('select[name="selling_plan"][form="' + form.id + '"]');
      if (externalSelect) return externalSelect.value || '';
    }

    return '';
  }

  function getFormErrorContainer(form) {
    var holder = form.closest('[data-section-id], quick-add-modal, product-info');
    if (!holder) return null;
    return holder.querySelector('[data-cart-errors-container]');
  }

  function ensureSellingPlanInput(form) {
    if (!form) return null;
    var input = form.querySelector('input[name="selling_plan"][data-selling-plan-guard]');
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'selling_plan';
      input.setAttribute('data-selling-plan-guard', 'true');
      form.appendChild(input);
    }
    return input;
  }

  function syncSellingPlanField(form, value) {
    if (!form) return '';
    var selectedSellingPlanId = value || '';
    var hiddenInput = ensureSellingPlanInput(form);
    if (hiddenInput) {
      hiddenInput.value = selectedSellingPlanId || '';
      if (!selectedSellingPlanId) {
        hiddenInput.disabled = true;
      } else {
        hiddenInput.disabled = false;
      }
    }
    return selectedSellingPlanId;
  }

  function renderError(form, message) {
    var container = getFormErrorContainer(form);
    if (!container) return;
    container.innerHTML = '<div class="errors">' + message + '</div>';
    container.classList.add('is-visible');
  }

  function clearError(form) {
    var container = getFormErrorContainer(form);
    if (!container) return;
    container.classList.remove('is-visible');
  }

  function setButtonsState(form, disabled) {
    var buttons = form.querySelectorAll('[type="submit"], [data-add-to-cart], [data-cart-bar-add-to-cart]');
    buttons.forEach(function (button) {
      if (!button.dataset.spInitialDisabled) {
        button.dataset.spInitialDisabled = button.disabled ? '1' : '0';
      }

      if (disabled) {
        button.dataset.spGuardDisabled = '1';
        button.disabled = true;
        button.setAttribute('aria-disabled', 'true');
      } else if (button.dataset.spGuardDisabled === '1') {
        delete button.dataset.spGuardDisabled;
        button.removeAttribute('aria-disabled');
        if (button.dataset.spInitialDisabled !== '1') {
          button.disabled = false;
        }
      }
    });
  }

  function validateFormSellingPlan(form, options) {
    if (!form) return { ok: true };
    var opts = options || {};
    var productInfo = form.closest('product-info');
    var productHandle = productInfo && productInfo.dataset ? productInfo.dataset.productHandle : '';
    var variant = getSelectedVariantData(productInfo);
    if (!variant) return { ok: true };

    var requiresSellingPlan = !!variant.requires_selling_plan;
    var selectedSellingPlanId = getSellingPlanFieldValue(form);
    if (requiresSellingPlan && !selectedSellingPlanId) {
      selectedSellingPlanId = getDefaultSellingPlanIdFromVariant(variant, productHandle);
    }

    syncSellingPlanField(form, requiresSellingPlan ? selectedSellingPlanId : '');
    var hasSellingPlan = !!selectedSellingPlanId;

    if (requiresSellingPlan && !hasSellingPlan) {
      if (opts.applyUi !== false) {
        setButtonsState(form, true);
        renderError(form, ERROR_TEXT);
      }
      return { ok: false, reason: 'missing-selling-plan' };
    }

    if (opts.applyUi !== false) {
      setButtonsState(form, false);
      clearError(form);
    }

    return { ok: true, sellingPlanId: selectedSellingPlanId };
  }

  function refreshAllProductForms() {
    document.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
      validateFormSellingPlan(form, { applyUi: true });
    });
  }

  function onCartAddCapture(event) {
    var detail = event.detail || {};
    var button = detail.button;
    if (!button) return;
    var form = button.form || button.closest('form');
    if (!form) return;

    var result = validateFormSellingPlan(form, { applyUi: true });
    if (result.ok) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    event.stopPropagation();

    button.dispatchEvent(
      new CustomEvent('theme:product:add-error', {
        detail: {
          response: {
            message: 'Selling plan required',
            description: ERROR_TEXT
          },
          button: button
        },
        bubbles: true
      })
    );
  }

  document.addEventListener('theme:cart:add', onCartAddCapture, true);

  document.addEventListener('change', function (event) {
    var target = event.target;
    if (!target) return;
    if (!target.closest('form[action*="/cart/add"]')) return;
    if (!target.matches('input[name="id"], select[name="id"], input[name="selling_plan"], select[name="selling_plan"], input[type="radio"], select')) return;
    refreshAllProductForms();
  });

  document.addEventListener('theme:product-info:loaded', refreshAllProductForms);
  document.addEventListener('shopify:section:load', refreshAllProductForms);
  document.addEventListener('DOMContentLoaded', refreshAllProductForms);

  if (document.readyState !== 'loading') {
    refreshAllProductForms();
  }
})();
